/*
 * Holly Palm — "Gelince Haber Ver" varyant senkronizasyonu.
 *
 * Symmetry theme.js varyant değişince .product-form üzerinde jQuery
 * 'variantChanged' event'i tetikler (ürün sayfası, hızlı al, öne çıkan ürün).
 * Burada:
 *   - seçili varyant stokta yoksa Sepete Ekle satırını gizleyip
 *     "Gelince Haber Ver" butonunu gösteriyoruz, stoktaysa tersi,
 *   - app'in okuduğu data-variant_id / data-product_price değerlerini güncelliyoruz.
 */
(function ($) {
  if (!$) return;

  function formatPrice(cents) {
    if (window.theme && theme.Shopify && typeof theme.Shopify.formatMoney === 'function') {
      // money_without_currency eşdeğeri: mağaza formatındaki {{ amount... }} kısmını kullan, sembolü at
      var match = String(theme.money_format || '').match(/\{\{\s*\w+\s*\}\}/);
      var formatted = theme.Shopify.formatMoney(cents, match ? match[0] : '{{amount}}');
      return String(formatted).replace(/<[^>]*>/g, '');
    }
    return (cents / 100).toFixed(2);
  }

  $(document).on('variantChanged', '.product-form', function (e, variant) {
    var $form = $(this);
    var $notify = $form.find('.hp-stock-notify');
    if (!$notify.length) return;

    var $notifyRow = $form.find('.hp-stock-notify-row');
    var $buyRow = $form.find('.quantity-submit-row');
    var soldOut = !!(variant && !variant.available);

    if (variant) {
      $notify.attr('data-variant_id', variant.id);
      $notify.attr('data-product_price', formatPrice(variant.price));
    }

    // Ürün tamamen tükendiyse sepete ekle satırı hiç basılmıyor → buton hep açık kalır.
    if (!$buyRow.length) {
      $notifyRow.prop('hidden', !variant);
      return;
    }

    $notifyRow.prop('hidden', !soldOut);
    $buyRow.prop('hidden', soldOut);
  });
})(window.jQuery);
